var secondaryDomain = location.hostname.replace(/^.+\.(\w+\.[a-z]{2,3})$/, '$1');
var thirdDomain = location.hostname.replace(/^(.+)\.\w+\.[a-z]{2,3}$/, '$1');
/**
 * 根据域名获取当前环境
 */
export function getEnv() {
    if (secondaryDomain === 'locxx.com') {
        return 'PE';
    }
    else if (secondaryDomain === 'lanhanba.com') {
        return 'SE';
    }
    else if (secondaryDomain === 'lanhanba.net') {
        if (thirdDomain === 'iepmspc') {
            return 'IE';
        }
        else {
            return 'TE';
        }
    }
    else {
        return 'develop';
    }
}
